import { PackagePosition } from "../../Models/Package/PackagePosition";
import { PersonType } from "../../Models/Tickets/PersonType";
import { Product } from "../../Models/Tickets/Product";

export class ProductMapper {
    GetPersonTypeList(productList: Product[]): PersonType[] {
        let personTypes: PersonType[] = [];
        for (let prod of productList) {
            if (prod.Quantity > 0) {
                personTypes.push({
                    PersonTypeId: prod.SubProductIdentifier,
                    Quantity: prod.Quantity
                });
            }
        }
        return personTypes;
    }

    GetPackagePositionList(productList: Product[]): PackagePosition[] {
        let positions: PackagePosition[] = [];
        for (let prod of productList) {
            positions.push({
                PackPos: prod.SubProductIdentifier,
                Quantity: prod.Quantity,
                PackSort: prod.Sort
            });
        }
        return positions;
    }
}